import React from 'react';
import Dropzone from "react-dropzone";
import {DROPZONE_ACCEPTED_FILES} from "../../helpers/variables";
import FormGroupTextInput from "../formGroupTextInput";
import GeneralSVG from "../generalSVG";
import FormGroupPlainText from "../formGroupPlainText";

const OverviewTabFormFile = (props) => {
    return (
        <div>
            {  props.attachmentIndex > 0 && (
                <FormGroupPlainText
                    InputWrapper="col-sm-6 formGroup-textInput-input-wrapper"
                    Required={false}
                    Label={<div
                        onClick={() => props.removeOverviewAttachment({attachmentIndex: props.attachmentIndex})}>
                        <GeneralSVG
                            SvgWrapper="generalTab-readMore-wrapper"
                            Label={'Remove'}
                            Svg={<svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 9.6 16"><title>
                                Asset
                                2</title>
                                <g id="Layer_2"
                                   data-name="Layer 2">
                                    <g id="Layer_1-2"
                                       data-name="Layer 1">
                                        <path
                                            d="M9.6,8.08a1.63,1.63,0,0,1-.48,1.16L2.81,15.53A1.63,1.63,0,0,1,.52,13.21L5.68,8.07.47,2.78A1.63,1.63,0,1,1,2.78.49L9.13,6.94A1.63,1.63,0,0,1,9.6,8.08Z"/>
                                    </g>
                                </g>
                            </svg>}
                        /></div>
                    }
                />
            )}
            <div className="form-group">
                <div className="col-sm-3">
                    <label className="control-label.text-left formGroup-textInput-label">
                        Upload File
                    </label>
                </div>
                <div className="col-sm-6 updateTab-dropzone-wrapper">
                    <div className="col-sm-8 updateTab-upload-label-wrapper">
                        <Dropzone
                            onDropAccepted={(files) => props.onAttachmentDrop(files, props.attachmentIndex)}
                            accept={DROPZONE_ACCEPTED_FILES}
                            multiple={false}
                            style={{width: '100%'}}
                            className="formGroup-textInput-input newApplication-upload-element ">
                            <p className="longWordBreak">{props.attachment.attachment.name?
                                props.attachment.attachment.name:'Drag and drop.'}</p>
                        </Dropzone>
                    </div>
                    <div className="col-sm-4 updateTab-upload-button-wrapper longWordBreak">
                        <Dropzone
                            onDropAccepted={(files) => props.onAttachmentDrop(files, props.attachmentIndex)}
                            accept={DROPZONE_ACCEPTED_FILES}
                            multiple={false}
                            className="updateTab-upload-wrapper newApplication-upload-element ">
                            <p>Choose File</p>
                        </Dropzone>
                        <svg className="updateTab-upload-arrow" xmlns="http://www.w3.org/2000/svg"
                             viewBox="0 0 9.6 16"><title>Asset 2</title>
                            <g id="Layer_2" data-name="Layer 2">
                                <g id="Layer_1-2" data-name="Layer 1">
                                    <path
                                        d="M9.6,8.08a1.63,1.63,0,0,1-.48,1.16L2.81,15.53A1.63,1.63,0,0,1,.52,13.21L5.68,8.07.47,2.78A1.63,1.63,0,1,1,2.78.49L9.13,6.94A1.63,1.63,0,0,1,9.6,8.08Z"/>
                                </g>
                            </g>
                        </svg>
                    </div>
                </div>
                <div ></div>
            </div>
            <FormGroupTextInput
                Disabled={false}
                InputWrapper="col-sm-6 formGroup-textInput-input-wrapper"
                Label="Add Tags (separate with commas)"
                Required={false}
                Name="tags"
                Type="text"
                Value={props.attachment.tags}
                HandleInputChange={(name, value) => props.changeOverviewAttachment({
                    key: name,
                    attachmentIndex: props.attachmentIndex,
                    value: value
                })}/>
            <div className="row">
                <div className="col-sm-9">
                    <hr className="generalTab-hr"/>
                </div>
            </div>
        </div>
    )
};



export default OverviewTabFormFile;